<template>
    <div>
        <Header></Header>
        <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>    
            
        </div>
        <div class="">
          <fade-transition  mode="out-in" :duration="1000">
                <router-view/>
            </fade-transition>
        </div>
    </section>
        <!-- <basic-elements></basic-elements>
        <inputs></inputs>
        <custom-controls></custom-controls>
        <navigation></navigation>
        <javascript-components></javascript-components>
        <icons></icons>
        <examples></examples>
        <download-section></download-section>
        <carousel></carousel> -->

      

        <Footer></Footer>
    </div>
</template>
<script>
import Hero from "./components/Hero";
import Header from "../layout/AppHeader.vue";
import Footer from "../layout/AppFooter.vue";

// import BasicElements from "./components/outros/BasicElements";
// import Inputs from "./components/outros/Inputs";
// import CustomControls from "./components/outros/CustomControls";
// import Navigation from "./components/outros/Navigation";
// import JavascriptComponents from "./components/outros/JavascriptComponents";
// import Carousel from "./components/outros/Carousel";
// import Icons from "./components/outros/Icons";
// import Examples from "./components/outros/Examples";
// import DownloadSection from "./components/outros/DownloadSection";
import { FadeTransition } from "vue2-transitions";

export default {
  name: "components",
  components: {
    Hero,
    FadeTransition,
    // BasicElements,
    // Inputs,
    // CustomControls,
    // Navigation,
    // JavascriptComponents,
    // Carousel,
    // Icons,
    // Examples,
    // DownloadSection
    Header,
    Footer
  }
};
</script>
<style  scoped>

</style>
